<template>
  <div class="flex flex-wrap" data-testid="tabs">
    <SummaryViewerTab
      v-for="tab in tabs"
      :id="tab.slug"
      :key="tab.name"
      class="text-xs md:text-base"
      :text="tab.name"
      :url="tab.url"
      :mobile-text="tab.mobileName || ''"
      :is-active="tab.slug === activeTabSlug"
      @click="$emit('active-tab-changed', tab.slug)"
    />
  </div>
</template>

<script setup lang="ts">
import SummaryViewerTab from '~/components/price-assessments/SummaryViewerTab.vue'
import type { TTab } from '~/src/types/ui'
import { useRoute } from '#app'

/*-------------------------------------
  Props & Refs
-------------------------------------*/
const props = defineProps<{
  tabs: TTab[]
}>()

const emit = defineEmits<{
  'active-tab-changed': [tab: string]
}>()

const route = useRoute()

const activeTabSlug = computed(() => {
  const currentTabObject = props.tabs.find((tab) => route.path === tab.url)
  const currentTab = currentTabObject?.slug
  const fallbackTab = props.tabs[0]?.slug

  return currentTab || fallbackTab
})

/*-------------------------------------
  Lifecycle
-------------------------------------*/
watch(activeTabSlug, (value) => {
  emit('active-tab-changed', value)
})

onMounted(() => {
  emit('active-tab-changed', activeTabSlug.value)
})
</script>
